import { css } from 'styled-components';
import { CFBaseAvatarHelpers } from './styles';
import { CFTokens } from '../../tokens';
export const CFBaseAvatarStyles = {
    Image: css `
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: -1px;
    left: -1px;
    right: -1px;
    top: -1px;
    position: absolute;
    background-color: transparent;
  `,
    ImageWeb: css `
    object-fit: cover;
    width: 100%;
    height: 100%;
  `,
    Initials: css `
    color: ${CFBaseAvatarHelpers.initialsColor};
    text-align: center;
    font-family: ${CFTokens.FONT_FAMILY.ARCHIVO.SEMIBOLD};
    font-size: ${CFBaseAvatarHelpers.fontSize}px;
  `,
    Root: css `
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-color: ${CFBaseAvatarHelpers.backgroundColor};
    border-radius: ${CFBaseAvatarHelpers.borderRadius}px;
    ${CFBaseAvatarHelpers.avatarSize};
    ${CFBaseAvatarHelpers.border};
  `,
};
